// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"c9a87958","226":"b3f9ced5","453":"f99e53e8","560":"77132c49","601":"12b09a1b"}[chunkId] + ".chunk.js";
};